import { InputContent } from './InputContent'
import { InputIcon } from './InputIcon'
import { InputRoot } from './InputRoot'
import { InputWrapper } from './InputWrapper'
import { InputLabel } from './InputLabel'

export const Input = {
  Root: InputRoot,
  Label: InputLabel,
  Wrapper: InputWrapper,
  Content: InputContent,
  Icon: InputIcon,
}
